import { Marker } from 'react-leaflet';
import L from 'leaflet';

// Component for displaying a Leaflet marker on the map

function ColoredMarker({ position, color, isActive, subcatIcon, onClick, children }) {

  // Enlarge the marker if it is active during a tour
  const size = isActive ? 25 : 20;

  const icon = L.divIcon({
    className: 'ColoredMarker',
    html: `
      ${isActive ? '<div class="pulse-ring"></div>' : ''}
      <div class="marker-circle" style="
        background-color: ${color};
        width: ${size}px;
        height: ${size}px;
        font-size: ${size / 1.5}px;
      ">
        ${subcatIcon || ''}
      </div>
    `,
    iconSize: [size, size],
    iconAnchor: [size / 2, size / 2],
  });

  return (
    <Marker position={position} icon={icon} eventHandlers={{ click: onClick }}>
      {children}
    </Marker>
  );
}

export default ColoredMarker;